module.exports = __webpack_public_path__ + "img/yad_no.d9ce7b23.png";